// Collection H. — custom interactions
(function () {
  'use strict';

  // ---------- Size guide modal (WCAG 2.1.2 focus trap + return focus) ----------
  var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var lastFocusedTrigger = null;

  function getFocusable(el) {
    return Array.prototype.slice.call(el.querySelectorAll(focusableSelector))
      .filter(function (n) { return n.offsetParent !== null || n === document.activeElement; });
  }

  function openModal(id, trigger) {
    var el = document.getElementById(id);
    if (!el) {
      if (id === 'ch-size-guide') window.location.href = '/pages/guide-des-tailles';
      return false;
    }
    lastFocusedTrigger = trigger || document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    el.removeAttribute('inert');
    document.body.style.overflow = 'hidden';
    // Move focus inside the modal (first focusable, else the panel itself)
    var focusables = getFocusable(el);
    var target = focusables[0] || el.querySelector('.ch-modal__panel') || el;
    if (target) {
      if (!target.hasAttribute('tabindex') && target === el.querySelector('.ch-modal__panel')) {
        target.setAttribute('tabindex', '-1');
      }
      setTimeout(function () { target.focus(); }, 0);
    }
    return true;
  }

  function closeModal(el) {
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('inert', '');
    document.body.style.overflow = '';
    // Return focus to the element that opened the modal
    if (lastFocusedTrigger && typeof lastFocusedTrigger.focus === 'function') {
      lastFocusedTrigger.focus();
    }
    lastFocusedTrigger = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-modal]');
    if (opener) {
      e.preventDefault();
      openModal(opener.getAttribute('data-open-modal'), opener);
      return;
    }
    if (e.target.matches('.ch-modal') || e.target.matches('[data-close-modal]')) {
      var modal = e.target.closest('.ch-modal');
      if (modal) closeModal(modal);
    }
  });

  document.addEventListener('keydown', function (e) {
    var openModalEl = document.querySelector('.ch-modal.is-open');
    if (!openModalEl) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      closeModal(openModalEl);
      return;
    }
    // Focus trap on Tab
    if (e.key === 'Tab') {
      var focusables = getFocusable(openModalEl);
      if (focusables.length === 0) { e.preventDefault(); return; }
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      var active = document.activeElement;
      if (e.shiftKey && active === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && active === last) {
        e.preventDefault(); first.focus();
      } else if (!openModalEl.contains(active)) {
        // Focus was outside the modal (e.g. after a click on body) — pull it back in
        e.preventDefault(); first.focus();
      }
    }
  });

  // ---------- Sticky ATC mobile bar ----------
  function initStickyAtc() {
    var bar = document.querySelector('.ch-sticky-atc');
    var trigger = document.querySelector('[data-sticky-atc-trigger]') ||
                  document.querySelector('product-form-component') ||
                  document.querySelector('form[action*="/cart/add"]');
    if (!bar || !trigger) return;

    function setVisible(on) {
      bar.classList.toggle('is-visible', on);
      // Keep aria-hidden in sync with actual visibility so screen readers
      // don't try to announce a hidden bar or skip a visible one.
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setVisible(false);
        } else if (entry.boundingClientRect.top < 0) {
          setVisible(true);
        } else {
          setVisible(false);
        }
      });
    }, { threshold: 0 });
    io.observe(trigger);

    // Sticky bar ATC click forwards to main form button
    var btn = bar.querySelector('[data-sticky-atc-submit]');
    if (btn) {
      btn.addEventListener('click', function () {
        var mainBtn = trigger.querySelector('button[type="submit"], [name="add"]');
        if (mainBtn) mainBtn.click();
        else trigger.requestSubmit && trigger.requestSubmit();
      });
    }
  }

  window.CHOpenModal = openModal;

  if (document.readyState !== 'loading') initStickyAtc();
  else document.addEventListener('DOMContentLoaded', initStickyAtc);
  document.addEventListener('shopify:section:load', initStickyAtc);

  // ---------- Footer accordéon mobile : collapse par défaut < 750px ----------
  function syncFooterAccordion() {
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    document.querySelectorAll('.ch-footer-col').forEach(function (d) {
      var summary = d.querySelector('summary');
      if (isMobile) {
        // Garde l'état utilisateur s'il a explicitement cliqué (data-user-toggled)
        if (!d.hasAttribute('data-user-toggled')) d.removeAttribute('open');
        if (summary) summary.setAttribute('tabindex', '0');
      } else {
        d.setAttribute('open', '');
        if (summary) summary.setAttribute('tabindex', '-1');
      }
    });
  }
  document.querySelectorAll('.ch-footer-col').forEach(function (d) {
    d.addEventListener('toggle', function () { d.setAttribute('data-user-toggled', '1'); });
  });
  syncFooterAccordion();
  var resizeT;
  window.addEventListener('resize', function () {
    clearTimeout(resizeT);
    resizeT = setTimeout(syncFooterAccordion, 150);
  });

  // ---------- Mega-menu Boutique : persistance hover (grace period) ----------
  function initMegaMenu() {
    var triggers = document.querySelectorAll('.ch-mega-trigger');
    triggers.forEach(function (trigger) {
      var menu = trigger.querySelector('.ch-mega--boutique');
      if (!menu) return;
      var closeTimer = null;
      function open() {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        trigger.classList.add('is-open');
      }
      function scheduleClose() {
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          trigger.classList.remove('is-open');
        }, 350);
      }
      trigger.addEventListener('mouseenter', open);
      trigger.addEventListener('focusin', open);
      trigger.addEventListener('mouseleave', scheduleClose);
      trigger.addEventListener('focusout', function (e) {
        if (!trigger.contains(e.relatedTarget)) scheduleClose();
      });
      menu.addEventListener('mouseenter', open);
      menu.addEventListener('mouseleave', scheduleClose);
    });
  }
  if (document.readyState !== 'loading') initMegaMenu();
  else document.addEventListener('DOMContentLoaded', initMegaMenu);
  document.addEventListener('shopify:section:load', initMegaMenu);

  // ---------- Désactive le hover-swap sur les cartes produit à 0 ou 1 image
  // (sinon Horizon tente de basculer vers une slide inexistante → page blanche) ----------
  function disableSingleImageHover() {
    document.querySelectorAll('.card-gallery').forEach(function (g) {
      var slides = g.querySelectorAll('slideshow-slide');
      if (slides.length <= 1) {
        g.removeAttribute('on:pointerenter');
        g.removeAttribute('on:pointerleave');
        g.classList.add('ch-no-hover-swap');
        // Si aucune image, fallback: fond neutre + pas de slideshow vide
        if (slides.length === 0) {
          g.style.backgroundColor = 'var(--ch-bone, #f5f0e8)';
        }
      }
    });
  }
  if (document.readyState !== 'loading') disableSingleImageHover();
  else document.addEventListener('DOMContentLoaded', disableSingleImageHover);
  document.addEventListener('shopify:section:load', disableSingleImageHover);

  // ---------- Faster navigation: prefetch likely same-origin pages on intent ----------
  function initIntentPrefetch() {
    if (!document.head || !('querySelector' in document)) return;
    var prefetched = {};
    var count = 0;
    var maxPrefetches = 10;
    var blocked = /^\/(?:cart|checkout|account|admin)(?:\/|$)/;

    function prefetch(link) {
      if (!link || count >= maxPrefetches) return;
      if (link.target || link.hasAttribute('download') || link.closest('[data-no-prefetch], [data-no-prerender]')) return;
      var url;
      try {
        url = new URL(link.getAttribute('href'), window.location.origin);
      } catch (error) {
        return;
      }
      if (url.origin !== window.location.origin || (url.hash && url.pathname === window.location.pathname)) return;
      if (blocked.test(url.pathname) || prefetched[url.href]) return;
      prefetched[url.href] = true;
      count += 1;
      var node = document.createElement('link');
      node.rel = 'prefetch';
      node.as = 'document';
      node.href = url.href;
      document.head.appendChild(node);
    }

    function schedule(event) {
      if (!(event.target instanceof Element)) return;
      var link = event.target.closest('a[href]');
      if (!link) return;
      var run = function () { prefetch(link); };
      if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 700 });
      else window.setTimeout(run, 80);
    }

    document.addEventListener('pointerover', schedule, { passive: true });
    document.addEventListener('touchstart', schedule, { passive: true });
  }
  if (document.readyState !== 'loading') initIntentPrefetch();
  else document.addEventListener('DOMContentLoaded', initIntentPrefetch);

  // ---------- Judge.me: keep product reviews visible near the price ----------
  function normalizeJudgeMeReviews(root) {
    var scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    var reviewAnchors = Array.prototype.slice.call(scope.querySelectorAll('.ch-pdp-reviews--judge'));

    reviewAnchors.forEach(function (anchor) {
      var badge = anchor.querySelector('.jdgm-prev-badge');
      if (!badge) return;
      var count = parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10);
      if (!count) return;
      var rating = badge.getAttribute('data-average-rating') || '5';
      rating = rating.replace(/\.00$/, '');
      anchor.setAttribute('href', '#avis');
      anchor.setAttribute('data-ch-open-reviews', '');
      anchor.innerHTML =
        '<span class="ch-pdp-reviews__stars" aria-hidden="true">★★★★★</span>' +
        '<span class="ch-pdp-reviews__count">' + rating + '/5 · ' + count + ' avis</span>';
    });

    var topReview = document.querySelector('.ch-pdp-reviews--judge, .ch-pdp-reviews--empty');
    if (!topReview) return;

    var existingTarget = document.getElementById('avis');
    if (
      existingTarget &&
      existingTarget !== topReview &&
      !existingTarget.classList.contains('ch-judge-reviews--empty') &&
      existingTarget.previousElementSibling !== topReview
    ) {
      topReview.insertAdjacentElement('afterend', existingTarget);
    }

    document.querySelectorAll('section.ch-judge-reviews').forEach(function (section) {
      var widget = section.querySelector('.jdgm-widget');
      var hasReviews = widget && widget.textContent && widget.textContent.trim().length > 0;
      if (!hasReviews) {
        section.classList.add('ch-judge-reviews--empty');
        section.setAttribute('aria-hidden', 'true');
        return;
      }
      if (section.dataset.chInline === 'true') return;
      section.dataset.chInline = 'true';
      if (!section.querySelector('summary')) {
        var details = document.createElement('details');
        details.className = section.className;
        details.id = section.id || 'avis';
        details.dataset.chInline = 'true';
        var summary = document.createElement('summary');
        summary.textContent = 'Lire les avis';
        details.appendChild(summary);
        while (section.firstChild) details.appendChild(section.firstChild);
        section.replaceWith(details);
        section = details;
      }
      topReview.insertAdjacentElement('afterend', section);
    });
  }
  if (document.readyState !== 'loading') normalizeJudgeMeReviews();
  else document.addEventListener('DOMContentLoaded', normalizeJudgeMeReviews);
  document.addEventListener('shopify:section:load', function (event) {
    normalizeJudgeMeReviews(event.target);
  });
  window.setTimeout(normalizeJudgeMeReviews, 600);
  window.setTimeout(normalizeJudgeMeReviews, 1800);
  window.setTimeout(normalizeJudgeMeReviews, 3500);

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-ch-open-reviews]');
    if (!link) return;
    var target = document.getElementById('avis');
    if (!target) return;
    event.preventDefault();
    normalizeJudgeMeReviews();
    target = document.getElementById('avis');
    if (target && target.tagName === 'DETAILS') {
      target.open = true;
      target.removeAttribute('aria-hidden');
    }
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  // ---------- A11y: hidden slideshow slides must not stay tabbable ----------
  function syncSlideshowSlideFocus(slide) {
    if (!slide || slide.tagName !== 'SLIDESHOW-SLIDE') return;
    slide.inert = slide.getAttribute('aria-hidden') === 'true' || slide.hasAttribute('hidden');
  }
  function syncHiddenSlideshowFocus(root) {
    var scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    scope.querySelectorAll('slideshow-slide').forEach(syncSlideshowSlideFocus);
  }
  if (document.readyState !== 'loading') syncHiddenSlideshowFocus();
  else document.addEventListener('DOMContentLoaded', syncHiddenSlideshowFocus);
  document.addEventListener('shopify:section:load', syncHiddenSlideshowFocus);
  document.addEventListener('slideshow:select', syncHiddenSlideshowFocus);
  if ('MutationObserver' in window) {
    var slideshowFocusObserver = new MutationObserver(function (records) {
      records.forEach(function (record) { syncSlideshowSlideFocus(record.target); });
    });
    slideshowFocusObserver.observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'hidden']
    });
  }

  function syncInvisibleZoomButtonFocus() {
    document.querySelectorAll('.product-media-container__zoom-button').forEach(function (button) {
      var styles = window.getComputedStyle(button);
      var rect = button.getBoundingClientRect();
      var isInvisible = styles.display === 'none' || styles.visibility === 'hidden' || rect.width < 1 || rect.height < 1;
      if (isInvisible) {
        button.setAttribute('tabindex', '-1');
        button.setAttribute('aria-hidden', 'true');
      } else {
        button.removeAttribute('tabindex');
        button.removeAttribute('aria-hidden');
      }
    });
  }
  if (document.readyState !== 'loading') syncInvisibleZoomButtonFocus();
  else document.addEventListener('DOMContentLoaded', syncInvisibleZoomButtonFocus);
  document.addEventListener('shopify:section:load', syncInvisibleZoomButtonFocus);
  var zoomFocusRaf = null;
  window.addEventListener('resize', function () {
    if (zoomFocusRaf) return;
    zoomFocusRaf = window.requestAnimationFrame(function () {
      zoomFocusRaf = null;
      syncInvisibleZoomButtonFocus();
    });
  });

  // ---------- PDP gallery: clicking the image opens the gallery zoom ----------
  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;
    var interactive = e.target.closest('button, a, input, select, textarea, video, model-viewer, product-model, zoom-dialog');
    if (interactive) return;

    var mediaContainer = e.target.closest('media-gallery .product-media-container');
    if (!mediaContainer) return;

    var zoomButton = mediaContainer.querySelector('.product-media-container__zoom-button');
    if (!zoomButton) return;

    e.preventDefault();
    zoomButton.click();
  });

  // ---------- Reservation anchors: land on the usable form, not the intro text ----------
  function scrollReservationHash(hash) {
    if (hash !== '#reservation-showroom' && hash !== '#reservation-conseil') return false;
    var root = document.querySelector(hash);
    if (!root) return false;
    var form = root.querySelector('form, input, select, textarea, button[type="submit"]');
    var target = form || root;
    window.setTimeout(function () {
      target.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }, 40);
    return true;
  }

  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;
    var link = e.target.closest('a[href^="#reservation-showroom"], a[href^="#reservation-conseil"]');
    if (!link) return;
    var hash = new URL(link.getAttribute('href'), window.location.href).hash;
    if (!scrollReservationHash(hash)) return;
    e.preventDefault();
    history.pushState(null, '', hash);
  });

  if (window.location.hash) {
    if (document.readyState !== 'loading') scrollReservationHash(window.location.hash);
    else document.addEventListener('DOMContentLoaded', function () { scrollReservationHash(window.location.hash); });
  }

  // ---------- Size tables : data-label sur les <td> pour layout cards mobile ----------
  function annotateSizeTables() {
    document.querySelectorAll('.ch-modal table.ch-size-table').forEach(function (table) {
      var headers = Array.from(table.querySelectorAll('thead th')).map(function (th) { return th.textContent.trim(); });
      if (!headers.length) return;
      table.querySelectorAll('tbody tr').forEach(function (tr) {
        Array.from(tr.children).forEach(function (td, i) {
          if (headers[i]) td.setAttribute('data-label', headers[i]);
        });
      });
    });
  }
  if (document.readyState !== 'loading') annotateSizeTables();
  else document.addEventListener('DOMContentLoaded', annotateSizeTables);

  // ---------- Hidden controls must not stay interactive ----------
  function syncHiddenInteractiveState() {
    document.querySelectorAll('.sticky-add-to-cart__bar').forEach(function (bar) {
      var styles = window.getComputedStyle(bar);
      var rect = bar.getBoundingClientRect();
      var visible = bar.getAttribute('data-stuck') === 'true' &&
        styles.display !== 'none' &&
        styles.visibility !== 'hidden' &&
        rect.width > 0 &&
        rect.height > 0;
      var ariaHidden = visible ? 'false' : 'true';
      if (bar.getAttribute('aria-hidden') !== ariaHidden) bar.setAttribute('aria-hidden', ariaHidden);
      bar.toggleAttribute('inert', !visible);
      bar.querySelectorAll('button, a, input, select, textarea').forEach(function (node) {
        if (visible && node.getAttribute('tabindex') === '-1') node.removeAttribute('tabindex');
        else if (!visible && node.getAttribute('tabindex') !== '-1') node.setAttribute('tabindex', '-1');
      });
    });

    document.querySelectorAll('.quick-add, .quick-add__button, .product-card button').forEach(function (node) {
      var hidden = window.getComputedStyle(node).display === 'none' || window.getComputedStyle(node).visibility === 'hidden';
      node.toggleAttribute('inert', hidden);
      var ariaHidden = hidden ? 'true' : 'false';
      if (node.getAttribute('aria-hidden') !== ariaHidden) node.setAttribute('aria-hidden', ariaHidden);
    });
  }
  if (document.readyState !== 'loading') syncHiddenInteractiveState();
  else document.addEventListener('DOMContentLoaded', syncHiddenInteractiveState);
  var hiddenInteractiveRaf = null;
  function requestSyncHiddenInteractiveState() {
    if (hiddenInteractiveRaf) return;
    hiddenInteractiveRaf = window.requestAnimationFrame(function () {
      hiddenInteractiveRaf = null;
      syncHiddenInteractiveState();
    });
  }
  document.addEventListener('shopify:section:load', requestSyncHiddenInteractiveState);
  document.addEventListener('scroll', requestSyncHiddenInteractiveState, { passive: true });
  if ('MutationObserver' in window) {
    new MutationObserver(requestSyncHiddenInteractiveState).observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['data-stuck', 'style', 'class', 'hidden']
    });
  }

  // ---------- Heading hygiene: keep one H1 per page after admin content renders ----------
  function demoteDuplicateH1() {
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;
    var headings = Array.prototype.slice.call(main.querySelectorAll('h1'));
    if (headings.length <= 1) return;
    headings.slice(1).forEach(function (h1) {
      var h2 = document.createElement('h2');
      Array.prototype.slice.call(h1.attributes).forEach(function (attr) {
        h2.setAttribute(attr.name, attr.value);
      });
      h2.innerHTML = h1.innerHTML;
      h1.replaceWith(h2);
    });
  }
  if (document.readyState !== 'loading') demoteDuplicateH1();
  else document.addEventListener('DOMContentLoaded', demoteDuplicateH1);
  document.addEventListener('shopify:section:load', demoteDuplicateH1);

  // ---------- Collection copy fallback for Shopify dynamic-source limits ----------
  function polishCollectionAllCopy() {
    if (window.location.pathname.replace(/\/$/, '') !== '/collections/all') return;
    document.body.classList.add('ch-template-collection-all');
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;
    var h1 = main.querySelector('h1');
    if (h1) h1.textContent = 'Toute la sélection Collection H.';
    if (!main.querySelector('.ch-collection-all-intro')) {
      var intro = document.createElement('div');
      intro.className = 'ch-collection-all-intro';
      intro.innerHTML = '<p>Des pièces choisies par Hélène pour composer une garde-robe féminine, confortable et facile à porter. <a href="/pages/contact">Besoin d’un conseil taille ? Écris à Hélène.</a></p>';
      if (h1 && h1.parentNode) h1.insertAdjacentElement('afterend', intro);
    }
  }
  if (document.readyState !== 'loading') polishCollectionAllCopy();
  else document.addEventListener('DOMContentLoaded', polishCollectionAllCopy);
  document.addEventListener('shopify:section:load', polishCollectionAllCopy);

  function hydrateCollectionAllNewestGrid() {
    if (window.location.pathname.replace(/\/$/, '') !== '/collections/all') return;
    var params = new URLSearchParams(window.location.search);
    if (params.has('sort_by')) return;

    var grid = document.querySelector('#ResultsList [ref="grid"], .product-grid[data-testid="product-grid"]');
    if (!grid || grid.dataset.chNewestHydrated === 'true') return;

    params.set('sort_by', 'created-descending');
    var url = window.location.pathname + '?' + params.toString();
    if (window.location.hash) url += window.location.hash;

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Collection sort fetch failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sourceGrid = doc.querySelector('#ResultsList [ref="grid"], .product-grid[data-testid="product-grid"]');
        if (!sourceGrid) return;

        var sourceCards = Array.prototype.slice.call(sourceGrid.querySelectorAll(':scope > [ref="cards[]"]'));
        if (!sourceCards.length) return;

        Array.prototype.slice.call(grid.querySelectorAll(':scope > [ref="cards[]"]')).forEach(function (card) {
          card.remove();
        });

        sourceCards.forEach(function (card) {
          grid.appendChild(document.importNode(card, true));
        });

        grid.dataset.chNewestHydrated = 'true';
        prioritizeCollectionAllClothing();
      })
      .catch(function () {
        prioritizeCollectionAllClothing();
      });
  }

  function prioritizeCollectionAllClothing() {
    if (window.location.pathname.replace(/\/$/, '') !== '/collections/all') return;
    var items = Array.prototype.slice.call(document.querySelectorAll('.product-grid__item, product-card'));
    if (!items.length) return;

    var clothing = /\b(chemise|chemisier|blouse|top|robe|combinaison|gilet|maille|pull|veste|manteau|jean|pantalon|jupe|short|t-shirt|d[ée]bardeur)\b/i;
    var outfitAccessories = /\b(sandale|basket|chaussure|sac)\b/i;
    var jewelry = /\b(bague|collier|bracelet|boucle|bijou|m[ée]daillon|perle)\b/i;

    items.forEach(function (item, index) {
      var text = (item.textContent || '').trim();
      var rank = 3;
      if (clothing.test(text)) rank = 0;
      else if (outfitAccessories.test(text)) rank = 1;
      else if (jewelry.test(text)) rank = 2;
      item.style.order = String((rank * 1000) + index);
    });
  }
  if (document.readyState !== 'loading') prioritizeCollectionAllClothing();
  else document.addEventListener('DOMContentLoaded', prioritizeCollectionAllClothing);
  document.addEventListener('shopify:section:load', prioritizeCollectionAllClothing);
  document.addEventListener('shopify:section:reorder', prioritizeCollectionAllClothing);
  window.setTimeout(prioritizeCollectionAllClothing, 800);
  if (document.readyState !== 'loading') hydrateCollectionAllNewestGrid();
  else document.addEventListener('DOMContentLoaded', hydrateCollectionAllNewestGrid);
  document.addEventListener('shopify:section:load', hydrateCollectionAllNewestGrid);

  // ---------- Custom cookie strip (replaces native shadow-DOM banner) ----------
  function initCookieStrip() {
    var strip = document.getElementById('ch-cookie-strip');
    if (!strip) return;
    if (strip.dataset.initialized === 'true') return;
    strip.dataset.initialized = 'true';
    var storageKey = 'ch-cookie-consent';
    var storedChoice = null;

    function removeNativeCookieUi() {
      document.querySelectorAll(
        '#shopify-pc__banner, #shopify-pc__prefs__dialog, .shopify-pc__banner__dialog, .shopify-pc__prefs__dialog'
      ).forEach(function (node) {
        node.setAttribute('aria-hidden', 'true');
        node.setAttribute('inert', '');
        node.remove();
      });
    }

    removeNativeCookieUi();
    window.setTimeout(removeNativeCookieUi, 400);
    window.setTimeout(removeNativeCookieUi, 1600);
    if ('MutationObserver' in window) {
      new MutationObserver(removeNativeCookieUi).observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }

    try {
      storedChoice = window.localStorage.getItem(storageKey);
    } catch (e) {
      storedChoice = null;
    }

    function showStrip() {
      strip.classList.add('is-visible');
      strip.setAttribute('aria-hidden', 'false');
      document.body.classList.add('has-cookie-strip');
    }

    function hideStrip() {
      strip.classList.remove('is-visible');
      strip.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('has-cookie-strip');
    }

    function isReady() {
      return !!(window.Shopify && window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function');
    }
    function whenReady(cb) {
      if (isReady()) { cb(); return; }
      // Shopify needs explicit loadFeatures to expose the consent API
      function tryLoad() {
        if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
            if (isReady()) cb();
          });
        }
      }
      tryLoad();
      document.addEventListener('shopify_customer_privacy_api_loaded', cb, { once: true });
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (isReady()) { clearInterval(iv); cb(); }
        else if (tries === 5 || tries === 15) { tryLoad(); }
        else if (tries > 40) { clearInterval(iv); }
      }, 200);
    }

    function applyConsent(value) {
      whenReady(function () {
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: value,
          marketing: value,
          preferences: value,
          sale_of_data: value
        }, function () {});
      });
    }

    if (storedChoice === 'accept' || storedChoice === 'decline') {
      hideStrip();
      applyConsent(storedChoice === 'accept');
      return;
    }

    window.setTimeout(showStrip, 450);

    whenReady(function () {
      var cp = window.Shopify.customerPrivacy;
      var current = cp.currentVisitorConsent && cp.currentVisitorConsent();
      var hasChoice = !!(current && (
        current.analytics === true || current.analytics === false ||
        current.analytics === 'yes' || current.analytics === 'no' ||
        current.marketing === true || current.marketing === false
      ));
      if (hasChoice) hideStrip();
    });

    strip.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cookie-action]');
      if (!btn) return;
      var action = btn.getAttribute('data-cookie-action');
      var accepted = action === 'accept';
      if (action !== 'accept' && action !== 'decline') return;
      try {
        window.localStorage.setItem(storageKey, accepted ? 'accept' : 'decline');
      } catch (err) {}
      hideStrip();
      applyConsent(accepted);
    });
  }
  if (document.readyState !== 'loading') initCookieStrip();
  else document.addEventListener('DOMContentLoaded', initCookieStrip);

  // ---------- Cart drawer "view cart" hard navigation ----------
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a.cart__view-cart-button[href]');
    if (!link) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.assign(link.href || '/cart');
  }, true);

  // ---------- Checkout fallback ----------
  function isLocalCheckoutHost() {
    return /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
  }

  function getRemoteCheckoutFallback() {
    var shopDomain = window.CollectionH && window.CollectionH.shopDomain;
    if (!shopDomain) return '/checkout';
    var url = new URL('/checkout', 'https://' + shopDomain);
    url.searchParams.set('skip_shop_pay', 'true');
    return url.href;
  }

  function getRemoteCartPermalink(cart) {
    var shopDomain = window.CollectionH && window.CollectionH.shopDomain;
    if (!shopDomain || !cart || !cart.items || !cart.items.length) return null;
    var items = cart.items
      .filter(function (item) { return item.variant_id && item.quantity > 0; })
      .map(function (item) { return item.variant_id + ':' + item.quantity; });
    if (!items.length) return null;
    var url = new URL('/cart/' + items.join(','), 'https://' + shopDomain);
    url.searchParams.set('skip_shop_pay', 'true');
    if (window.Shopify && window.Shopify.theme && window.Shopify.theme.id) {
      url.searchParams.set('preview_theme_id', window.Shopify.theme.id);
    }
    return url.href;
  }

  function redirectLocalCheckout() {
    var fallback = getRemoteCheckoutFallback();
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      })
      .then(function (cart) {
        window.location.assign(getRemoteCartPermalink(cart) || fallback);
      })
      .catch(function () {
        window.location.assign(fallback);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#checkout, .cart__checkout-button');
    if (!btn || btn.disabled) return;
    if (isLocalCheckoutHost()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      redirectLocalCheckout();
      return;
    }
    var startUrl = window.location.href;
    window.setTimeout(function () {
      if (window.location.href !== startUrl) return;
      window.location.href = '/checkout';
    }, 1200);
  }, true);

  // ---------- Conseil en image price cleanup ----------
  function initConseilImagePriceCleanup() {
    if (window.location.pathname.replace(/\/$/, '') !== '/pages/conseil-en-image') return;

    document.querySelectorAll('.ch-co-card__price').forEach(function (price) {
      price.remove();
    });

    document.querySelectorAll('.ch-co-presta__note').forEach(function (note) {
      var text = note.textContent || '';
      if (text.indexOf('\u20ac') !== -1 || /prix/i.test(text)) note.remove();
    });

    document.querySelectorAll('select[name="contact[Formule]"] option').forEach(function (option) {
      option.textContent = option.textContent.replace(/\s[\u2013\u2014-]\s\d+\s*\u20ac/g, '').trim();
    });
  }

  if (document.readyState !== 'loading') initConseilImagePriceCleanup();
  else document.addEventListener('DOMContentLoaded', initConseilImagePriceCleanup);

  // ---------- Collection image fallbacks ----------
  function initCollectionImageFallbacks() {
    var match = window.location.pathname.match(/^\/collections\/([^/?#]+)/);
    if (!match) return;

    var fallbackByCollection = {
      'robes-combinaisons': '//collectionh.fr/cdn/shop/collections/Capture_d_ecran_2026-03-30_a_09.51.07.png?v=1777643665&width=1200',
      'hauts': '//collectionh.fr/cdn/shop/collections/Capture_d_ecran_2026-03-30_a_09.50.06.png?v=1777643201&width=1200',
      'chemisiers-blouses': '//collectionh.fr/cdn/shop/collections/Capture_d_ecran_2026-03-30_a_09.49.17.png?v=1777643637&width=1200',
      'mailles-pull': '//collectionh.fr/cdn/shop/collections/Capture_d_ecran_2026-03-30_a_09.50.39.png?v=1777643612&width=1200',
      'vestes-manteaux': '//collectionh.fr/cdn/shop/collections/Capture_d_ecran_2026-03-30_a_09.51.27.png?v=1777643390&width=1200',
      'pantalons-jeans': '//collectionh.fr/cdn/shop/collections/Capture_d_ecran_2026-03-30_a_09.50.53.png?v=1777643307&width=1200',
      'jupes-shorts': '//collectionh.fr/cdn/shop/collections/Capture_d_ecran_2026-04-08_a_10.40.59.png?v=1777643826&width=1200',
      't-shirt-debardeurs': '//collectionh.fr/cdn/shop/collections/Capture_d_ecran_2026-03-30_a_10.01.11.png?v=1777643229&width=1200',
      'sacs': '//collectionh.fr/cdn/shop/collections/Capture_d_ecran_2026-03-30_a_09.51.17.png?v=1777643804&width=1200',
      'chaussures': '//collectionh.fr/cdn/shop/collections/Capture_d_ecran_2026-03-30_a_09.47.43.png?v=1777643455&width=1200',
      'bijoux': '//collectionh.fr/cdn/shop/collections/Capture_d_ecran_2026-03-30_a_09.44.15.png?v=1777643776&width=1200',
      'colliers': '//collectionh.fr/cdn/shop/collections/Capture_d_ecran_2026-03-30_a_09.49.32.png?v=1777643907&width=1200',
      'boucles-doreille': '//collectionh.fr/cdn/shop/collections/Capture_d_ecran_2026-03-30_a_09.45.10.png?v=1777643852&width=1200',
      'bracelets': '//collectionh.fr/cdn/shop/collections/Capture_d_ecran_2026-03-30_a_09.46.50.png?v=1777643695&width=1200',
      'bagues': '//collectionh.fr/cdn/shop/collections/Capture_d_ecran_2026-03-30_a_09.43.18.png?v=1777643878&width=1200'
    };
    var fallbackSrc = fallbackByCollection[match[1]];
    if (!fallbackSrc) return;

    var root = document.querySelector('results-list') || document;

    function applyFallback(image) {
      if (!image || image.dataset.chCategoryFallbackApplied === 'true') return;
      image.dataset.chCategoryFallbackApplied = 'true';
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.removeAttribute('data_max_resolution');
      image.src = fallbackSrc;
      image.classList.add('product-media__image--category-fallback');
    }

    function scanBrokenImages() {
      root.querySelectorAll('img.product-media__image').forEach(function (image) {
        if (image.complete && image.naturalWidth === 0) {
          applyFallback(image);
        }
      });
    }

    root.addEventListener('error', function (event) {
      var image = event.target;
      if (image instanceof HTMLImageElement && image.classList.contains('product-media__image')) {
        applyFallback(image);
      }
    }, true);

    scanBrokenImages();
    window.setTimeout(scanBrokenImages, 500);
    window.setTimeout(scanBrokenImages, 2000);
  }

  if (document.readyState !== 'loading') initCollectionImageFallbacks();
  else document.addEventListener('DOMContentLoaded', initCollectionImageFallbacks);

  // ---------- Encoding repair for stale Shopify-rendered HTML variants ----------
  function repairEncodingArtifacts(root) {
    var scope = root && root.nodeType ? root : document.body;
    if (!scope || !document.createTreeWalker) return;

    var replacements = [
      [/cr\uFFFDer/g, 'cr\u00E9er'],
      [/compl\uFFFDte/g, 'compl\u00E8te'],
      [/pi\uFFFDces/g, 'pi\u00E8ces'],
      [/nouveaut\uFFFDs/g, 'nouveaut\u00E9s'],
      [/\uFFFDt\uFFFD/g, '\u00E9t\u00E9'],
      [/fa\uFFFDon/g, 'fa\u00E7on'],
      [/H\uFFFDl\uFFFDne/g, 'H\u00E9l\u00E8ne'],
      [/S\uFFFDlection/g, 'S\u00E9lection'],
      [/s\uFFFDlection/g, 's\u00E9lection'],
      [/\uFFFDcris/g, '\u00C9cris'],
      [/d\uFFFDs/g, 'd\u00E8s'],
      [/r\uFFFDponds/g, 'r\u00E9ponds']
    ];

    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var value = node.nodeValue;
      if (!value || value.indexOf('\uFFFD') === -1) continue;
      replacements.forEach(function (pair) {
        value = value.replace(pair[0], pair[1]);
      });
      node.nodeValue = value;
    }
  }

  if (document.readyState !== 'loading') repairEncodingArtifacts();
  else document.addEventListener('DOMContentLoaded', repairEncodingArtifacts);
  document.addEventListener('shopify:section:load', function (event) {
    repairEncodingArtifacts(event.target);
  });
  window.setTimeout(repairEncodingArtifacts, 500);
  window.setTimeout(repairEncodingArtifacts, 1800);
})();
